<template>
  <a-card
    size="small"
    hoverable
    class="h-100 d-flex flex-column"
    style="flex: 30%"
    :body-style="{ height: '1px', flex: '1 1 auto', overflowY: 'auto' }"
  >
    <template #title>
      <span>{{ title }}:</span>
      <a-tag class="ml-2" color="processing">
        {{ items.length }}
      </a-tag>
    </template>
    <a-skeleton
      :loading="isTaskDetailsLoading"
      active
      :paragraph="{ rows: 13 }"
    >
      <ul id="infer-potential-issues-list" class="list-group">
        <li
          v-for="(item, index) in items"
          :id="'infer-potential-issue-li-' + index"
          :key="index"
          class="list-group-item list-group-item-danger h-auto"
          :class="{ clickable: item.time != null }"
          :role="item.time != null ? 'button' : null"
          @click="item.time != null && $emit('click-step', item)"
        >
          <span class="step-name">
            {{ stepsTranslationMapping[item.name] || item.name }}
          </span>
          <span v-if="item.time != null" class="step-time">
            {{ formatMmSs(item.time) }}
          </span>
        </li>
      </ul>
    </a-skeleton>
  </a-card>
</template>
<script>
export default {
  props: {
    items: { type: Array, default: () => [] },
    title: { type: String, default: 'Potential Issues' },
    stepsTranslationMapping: { type: Object, default: () => ({}) },
    isTaskDetailsLoading: { type: Boolean, default: false },
  },
  emits: ['click-step'],
  methods: {
    formatMmSs(sec) {
      const total = Math.max(0, Math.floor(sec));
      const minutes = Math.floor(total / 60);
      const seconds = total % 60;
      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    },
  },
};
</script>
<style scoped>
.list-group-item {
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.73em;
}
.list-group-item.clickable {
  cursor: pointer;
}
.step-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.step-time {
  margin-left: 8px;
  flex-shrink: 0;
  font-variant-numeric: tabular-nums;
}
</style>
